<template>
  <div v-if="initData" class="contianer-detail">
    <Modal title="不合格处理单" :value="value" :loading="loading" @on-ok="save" @on-visible-change="visibleChange" :mask-closable="false" width="860">
      <Form :model="initData" ref="initData" :rules="rules">
        <div class="cont">
          <div v-if="initData.isShow_不合格处理详情">
            <Divider v-if="initData.submitText">基本信息</Divider>
            <Row align="middle">
              <Col span="4">记录编号：</Col>
              <Col span="8">{{ initData.recordNumber }}</Col>
              <Col span="4">表单编号：</Col>
              <Col span="8">{{ initData.formNumber }}</Col>
            </Row>
            <Row align="middle">
              <Col span="4">类型：</Col>
              <Col span="8">{{ initData.productType_Text }}</Col>
              <Col span="4">物料名称：</Col>
              <Col span="8">{{ initData.materialName }}</Col>
            </Row>
            <Row align="middle">
              <Col span="4">规格/型号：</Col>
              <Col span="8">{{ initData.productSpecification }}</Col>
              <Col span="4">图号/物料编码：</Col>
              <Col span="8">{{ initData.materialCode }}</Col>
            </Row>
            <Row align="middle">
              <Col span="4">报告部门：</Col>
              <Col span="8">{{ initData.reportDepartment }}</Col>
              <Col span="4">发生时间：</Col>
              <Col span="8">{{ initData.occurrenceTimeText }}</Col>
            </Row>
            <Row align="middle">
              <Col span="4">责任单位/部门：</Col>
              <Col span="8">{{ initData.accountabilityUnit }}</Col>
              <Col span="4">责任人：</Col>
              <Col span="8">{{ initData.accountabilityUser }}</Col>
            </Row>
            <Row align="middle">
              <Col span="4">批次数量：</Col>
              <Col span="8">{{ initData.batchCount }}</Col>
              <Col span="4">不合格数量：</Col>
              <Col span="8">{{ initData.unacceptedCount }}</Col>
            </Row>
            <Row align="middle">
              <Col span="4">不良类别：</Col>
              <Col span="8">{{ initData.undesirableCategoryText }}</Col>
              <Col span="4">填写人：</Col>
              <Col span="8">{{ initData.writtenUser }}</Col>
            </Row>
            <Row align="middle">
              <Col span="4">不合格情况：</Col>
              <Col span="20">{{ initData.unacceptedDescribe }}</Col>
            </Row>
            <Row align="middle" v-if="initData.imageFiles.length != 0 || initData.videoFiles.length != 0">
              <Col span="4">相关图片：</Col>
              <Col span="8">
              <div class="img-box">
                <div v-for="item in initData.imageFiles" :key="item.fileGuids">
                  <img :src="$constDefinition.baseUrl + item.url" alt="" @click="previewImg(item.url)" />
                </div>
              </div>
              </Col>
              <Col span="4">相关视频：</Col>
              <Col span="8">
              <div class="img-box video-box">
                <div v-for="item in initData.videoFiles" :key="item.fileGuids">
                  <img src="@/assets/images/play.webp" class="icon" @click="previewVideo(item.url)" />
                  <!-- <video :src="$constDefinition.baseUrl+item.url" controls @click.prevent="previewImg(item.url)"></video> -->
                </div>
              </div>
              </Col>
            </Row>
            <Row align="middle">
              <Col span="4">提交时间：</Col>
              <Col span="20">{{ initData.submitText }}</Col>
            </Row>
            <Row align="middle" v-if="initData.status == $constDefinition.supervisorSendBack">
              <Col span="4">退回原因：</Col>
              <Col span="8">{{ initData.backReason }}</Col>
              <Col span="4">退回时间：</Col>
              <Col span="8">{{ initData.backTime_Text }}</Col>
            </Row>
            <FormItem class="label" prop="temporaryDisposePlanUserId" label="临时处理方案责任人：" required
              v-if="initData.is品质部部长 && (initData.status == $constDefinition.temporaryStorage || initData.status == $constDefinition.qualitySupervisorConfirm)">
              <RadioGroup v-model="initData.temporaryDisposePlanUserId">
                <Radio v-for="(item, index) in initData.gybUsers" :key="index" :label="item.departmentHeadUserId">{{ item.departmentHeadUserName }}</Radio>
              </RadioGroup>
            </FormItem>
            <Row align="middle" v-if="initData.status > $constDefinition.qualitySupervisorConfirm && initData.status < $constDefinition.supervisorSendBack">
              <Col span="4">确认主管：</Col>
              <Col span="8">{{ initData.qualitySupervisor }}</Col>
              <Col span="4">确认时间：</Col>
              <Col span="8">{{ initData.acknowledgingTimeText }}</Col>
            </Row>
          </div>

          <div v-if="initData.isShow_临时处理方案">
            <Divider v-if="initData.status >= $constDefinition.recordedProcessingPlan && initData.status < $constDefinition.supervisorSendBack">临时处理方案</Divider>
            <!-- 表单填写 -->
            <div v-if="initData.status == $constDefinition.recordedProcessingPlan">
              <!-- 驳回人驳回原因驳回时 -->
              <Row align="middle" v-if="initData.status == $constDefinition.recordedProcessingPlan && initData.sign_RejectedReason">
                <Col span="4">驳回原因：</Col>
                <Col span="20">{{ initData.sign_RejectedReason }}</Col>
              </Row>
              <Row align="middle" v-if="initData.status == $constDefinition.recordedProcessingPlan && initData.sign_RejectedReason">
                <Col span="4">驳回人：</Col>
                <Col span="8">{{ initData.sign_RejectedUserName }}</Col>
                <Col span="4">驳回时间：</Col>
                <Col span="8">{{ initData.sign_RejectedTimeText }}</Col>
              </Row>
              <FormItem prop="temporaryDisposePlan" label="临时处理方案：" required>
                <Input v-model="initData.temporaryDisposePlan" type="textarea" :maxlength="200" :autosize="{ minRows: 5, maxRows: 5 }" placeholder="请输入临时处理方案(最多200个字)" @input="handleStorageTemporaryDisposePlan"></Input>
              </FormItem>
              <FormItem prop="signRecordDtos" label="会签部门：" required>
                <CheckboxGroup v-model="initData.signRecordDtos" @change.native="changebox">
                  <Checkbox v-for="(item, index) in initData.signDepartments" :key="index" :label="item">{{ item.department }}</Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem :label="itm.department + '会签主管：'" v-for="(itm, ind) in initData.signRecordDtos" :key="ind" required>
                <CheckboxGroup v-model="signDepartmentInfos" @change.native="changebox">
                  <Checkbox v-for="(item, index) in itm.signDepartmentHeadUserInfos" :key="index" :label="item">{{ item.departmentHeadUserName }}</Checkbox>
                </CheckboxGroup>
              </FormItem>
            </div>
            <div v-else>
              <Row align="middle">
                <Col span="4">临时处理方案：</Col>
                <Col span="20">{{ initData.temporaryDisposePlan }}</Col>
              </Row>
              <Row align="middle">
                <Col span="4">填写人：</Col>
                <Col span="8">{{ initData.temporaryDisposePlanUser }}</Col>
                <Col span="4">提交时间：</Col>
                <Col span="8">{{ initData.temporaryDisposePlanSubmitTimeText }}</Col>
              </Row>
            </div>
            <!-- 会签部门确认状态 -->
            <Row align="middle" v-if="initData.status >= $constDefinition.countersignedDepartmentConfirm && initData.status < $constDefinition.supervisorSendBack">
              <Col span="24">
              <Table :columns="columnsSignRecordDtos" :data="initData.signRecordDtos"></Table>
              </Col>
            </Row>
          </div>

          <div v-if="initData.isShow_处置结论">
            <Divider v-if="initData.status >= $constDefinition.recordedDisposalConclusion && initData.status < $constDefinition.supervisorSendBack">处置结论</Divider>
            <!-- 处置结论 -->
            <div v-if="initData.status == $constDefinition.recordedDisposalConclusion">
              <FormItem prop="disposeConclusion" label="处置结论：">
                <RadioGroup v-model="initData.disposeConclusion" @change.native="changeConclusion">
                  <Radio v-for="item in initData.disposeConclusionData" :key="item.value" :label="item.value">{{ item.name }}</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem prop="disposeConclusionDescribe" v-if="initData.disposeConclusion == 30">
                <Input v-model="initData.disposeConclusionDescribe" type="textarea" :maxlength="200" :autosize="{ minRows: 5, maxRows: 5 }" placeholder="请输入其他处理内容(最多200个字)" @input="handleStorageDisposeConclusion"></Input>
              </FormItem>
              <FormItem prop="responsibilityDepartment" label="责任部门：">
                <RadioGroup v-model="initData.responsibilityDepartment" @change.native="changeDepartment">
                  <Radio v-for="(item, index) in initData.signDepartments" :key="index" :label="item.department">{{ item.department }}</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem prop="responsibilityDepartmentUserId" label="技术部成员：" required v-if="initData.responsibilityDepartment == '技术部'">
                <RadioGroup v-model="initData.responsibilityDepartmentUserId" @change.native="handleStorageDisposeConclusion">
                  <Radio v-for="(item, index) in initData.departmentEmployeeData[0].signDepartmentHeadUserInfos" :key="index" :label="item.departmentHeadUserId">{{ item.departmentHeadUserName }}</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem prop="responsibilityDepartmentUserId" label="工艺部成员：" required v-if="initData.responsibilityDepartment == '工艺部'">
                <RadioGroup v-model="initData.responsibilityDepartmentUserId" @change.native="handleStorageDisposeConclusion">
                  <Radio v-for="(item, index) in initData.departmentEmployeeData[1].signDepartmentHeadUserInfos" :key="index" :label="item.departmentHeadUserId">{{ item.departmentHeadUserName }}</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem prop="responsibilityDepartmentUserId" label="生产部成员：" required v-if="initData.responsibilityDepartment == '生产部'">
                <RadioGroup v-model="initData.responsibilityDepartmentUserId" @change.native="handleStorageDisposeConclusion">
                  <Radio v-for="(item, index) in initData.departmentEmployeeData[2].signDepartmentHeadUserInfos" :key="index" :label="item.departmentHeadUserId">{{ item.departmentHeadUserName }}</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem prop="responsibilityDepartmentUserId" label="采购部成员：" required v-if="initData.responsibilityDepartment == '采购部'">
                <RadioGroup v-model="initData.responsibilityDepartmentUserId" @change.native="handleStorageDisposeConclusion">
                  <Radio v-for="(item, index) in initData.departmentEmployeeData[3].signDepartmentHeadUserInfos" :key="index" :label="item.departmentHeadUserId">{{ item.departmentHeadUserName }}</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem prop="responsibilityDepartmentUserId" label="编程部成员：" required v-if="initData.responsibilityDepartment == '编程部'">
                <RadioGroup v-model="initData.responsibilityDepartmentUserId" @change.native="handleStorageDisposeConclusion">
                  <Radio v-for="(item, index) in initData.departmentEmployeeData[3].signDepartmentHeadUserInfos" :key="index" :label="item.departmentHeadUserId">{{ item.departmentHeadUserName }}</Radio>
                </RadioGroup>
              </FormItem>
            </div>
            <Row align="middle" v-if="initData.status > $constDefinition.recordedDisposalConclusion && initData.status < $constDefinition.supervisorSendBack">
              <Col span="4">处置结论：</Col>
              <Col span="8">{{ initData.disposeConclusionText }}</Col>
              <Col span="4">责任部门：</Col>
              <Col span="8">
              <div>
                {{ initData.responsibilityDepartmentUserName }}
              </div>
              </Col>
            </Row>
            <Row align="middle" v-if="initData.status > $constDefinition.recordedDisposalConclusion && initData.status < $constDefinition.supervisorSendBack">
              <Col span="4">填写人：</Col>
              <Col span="8">{{ initData.disposeConclusionUser }}</Col>
              <Col span="4">提交时间：</Col>
              <Col span="8">{{ initData.disposeConclusionSubmitTimeText }}</Col>
            </Row>
          </div>
          <div v-if="initData.isShow_原因分析">
            <Divider v-if="initData.status >= $constDefinition.recordedAnalysisCountermeasures && initData.status < $constDefinition.supervisorSendBack">原因分析/改善对策</Divider>
            <!-- 表单填写 -->
            <div v-if="initData.trackingVerificationConfirm_RejectedUserName">
              <div class="custom-block danger">
                <div>
                  <span class="custom-block-title">驳回理由：</span>{{ initData.trackingVerificationConfirm_RejectedReason }}
                </div>
                <div>
                  <span class="custom-block-title">驳回时间：</span>{{ initData.trackingVerificationConfirm_RejectedTime_Text }}
                </div>
                <div>
                  <span class="custom-block-title">驳回人：</span>{{ initData.trackingVerificationConfirm_RejectedUserName }}
                </div>
              </div>
            </div>
            <div v-if="initData.status == $constDefinition.recordedAnalysisCountermeasures">
              <FormItem prop="causeAnalysis" label="原因分析：">
                <Input v-model="initData.causeAnalysis" type="textarea" :maxlength="200" :autosize="{ minRows: 5, maxRows: 5 }" placeholder="请输入原因分析(最多200个字)" @input="handleStorageCauseAnalysis"></Input>
              </FormItem>
              <FormItem prop="improveCountermeasure" label="改善对策：">
                <Input v-model="initData.improveCountermeasure" type="textarea" :maxlength="200" :autosize="{ minRows: 5, maxRows: 5 }" placeholder="请输入改善对策(最多200个字)" @input="handleStorageCauseAnalysis"></Input>
              </FormItem>
              <!-- 3图片 4视频 -->
              <p class="title">相关图片</p>
              <div class="cont-img">
                <div class="demo-upload-list" v-for="(item, index) in initData.improveCountermeasureImageFiles" :key="item.fileGuids">
                  <img :src="$constDefinition.baseUrl + item.url" @click="previewImg(item.url)" />
                  <div class="demo-upload-list-cover">
                    <Icon type="ios-close" @click.native="handleRemove(item, index)"></Icon>
                  </div>
                </div>
                <Upload ref="upload" :show-upload-list="false" :on-success="handleSuccessImageFiles" :max-size="10240" multiple type="drag" accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.GIF,.PNG"
                  :action="$constDefinition.baseUrl + '/file/UploadByUnacceptedOrder'" :data="{ id: initData.id, type: 3, guid: this.imageFilesGuid }" style="width: 80px">
                  <div style="width: 80px; height: 80px; line-height: 80px" @click="handleBeforeImage">
                    <Icon type="ios-camera" size="20"></Icon>
                  </div>
                </Upload>
              </div>
              <p class="title">相关视频</p>
              <div class="cont-img">
                <div class="demo-upload-list" v-for="(item, index) in initData.improveCountermeasureVideoFiles" :key="item.fileGuids">
                  <img src="@/assets/images/play.webp" @click="previewVideo(item.url)" />
                  <div class="demo-upload-list-cover">
                    <Icon type="ios-close" @click.native="handleRemove(item, index)"></Icon>
                  </div>
                </div>
                <Upload ref="upload" :show-upload-list="false" :on-success="handleSuccessVideoFiles" :max-size="10240" multiple type="drag" accept=".mp3,.mp4,.avi,.wmv,.mpeg"
                  :action="$constDefinition.baseUrl + '/file/UploadByUnacceptedOrder'" :data="{ id: initData.id, type: 4, guid: this.videoFilesGuid }" style="width: 80px">
                  <div style="width: 80px; height: 80px; line-height: 80px" @click="handleBeforeVideo">
                    <Icon type="ios-camera" size="20"></Icon>
                  </div>
                </Upload>
              </div>
            </div>
            <Row align="middle" v-if="initData.status > $constDefinition.recordedAnalysisCountermeasures && initData.status < $constDefinition.supervisorSendBack">
              <Col span="4">原因分析：</Col>
              <Col span="20">{{ initData.causeAnalysis }}</Col>
            </Row>
            <Row align="middle" v-if="initData.status > $constDefinition.recordedAnalysisCountermeasures && initData.status < $constDefinition.supervisorSendBack">
              <Col span="4">改善对策：</Col>
              <Col span="20">{{ initData.improveCountermeasure }}</Col>
            </Row>
            <Row align="middle" v-if="initData.status > $constDefinition.recordedTrackingVerification && initData.status < $constDefinition.supervisorSendBack && initData.proveFiles.length != 0">
              <Col span="4">相关图片：</Col>
              <Col span="20">
              <div v-if="initData.improveCountermeasureImageFiles.length > 0" class="img-box">
                <div v-for="item in initData.improveCountermeasureImageFiles" :key="item.fileGuids">
                  <img :src="$constDefinition.baseUrl + item.url" @click="previewImg(item.url)" />
                </div>
              </div>
              </Col>
            </Row>
            <Row align="middle" v-if="initData.status > $constDefinition.recordedTrackingVerification && initData.status < $constDefinition.supervisorSendBack && initData.proveFiles.length != 0">
              <Col span="4">相关视频：</Col>
              <Col span="20">
              <div v-if="initData.improveCountermeasureVideoFiles.length > 0" class="img-box">
                <div v-for="item in initData.improveCountermeasureVideoFiles" :key="item.fileGuids">
                  <img src="@/assets/images/play.webp" @click="previewVideo(item.url)" />
                </div>
              </div>
              </Col>
            </Row>
            <Row align="middle" v-if="initData.status > $constDefinition.recordedAnalysisCountermeasures && initData.status < $constDefinition.supervisorSendBack">
              <Col span="4">填写人：</Col>
              <Col span="8">{{ initData.improveCountermeasureWrittenUser }}</Col>
              <Col span="4">提交时间：</Col>
              <Col span="8">{{ initData.improveCountermeasureWrittenDateText }}</Col>
            </Row>
          </div>

          <div v-if="initData.isShow_跟踪验证">
            <Divider v-if="initData.status >= $constDefinition.recordedTrackingVerification && initData.status < $constDefinition.supervisorSendBack">跟踪验证</Divider>
            <div v-if="initData.status == $constDefinition.recordedTrackingVerification">
              <FormItem prop="trackingVerification" label="跟踪验证：">
                <Input v-model="initData.trackingVerification" type="textarea" :maxlength="200" :autosize="{ minRows: 5, maxRows: 5 }" placeholder="请输入跟踪验证(最多200个字)" @input="handleStorageTrackingVerification"></Input>
              </FormItem>
              <FormItem prop="confirmUserIds" label="推送确认选择：">
                <Input search enter-button="搜 索" v-model="trackingVerificationName" placeholder="请输入姓名" @on-search="getTrackingVerificationName">
                </Input>
                <CheckboxGroup style="margin-top:10px;" v-model="initData.confirmUserIds">
                  <Checkbox v-for="(item, index) in initData.zdUserList" :key="index" :label="item.value">{{ item.name }}</Checkbox>
                  <Checkbox v-for="(item) in queryUserList" :key="item.value" :label="item.value">{{ item.name }}
                  </Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem label="推送人：">
                <Input v-model="confirmUserNames" readonly>
                <template #prefix>
                  <Icon type="ios-contact" />
                </template>
                </Input>
              </FormItem>
              <p class="title">相关文件</p>
              <div class="cont-img">
                <div class="demo-upload-list" v-for="(item, index) in initData.proveFiles" :key="item.fileGuids">
                  <img :src="$constDefinition.baseUrl + item.url" @click="previewImg(item.url)" />
                  <div class="demo-upload-list-cover">
                    <Icon type="ios-close" @click.native="handleRemove(item, index)"></Icon>
                  </div>
                </div>
                <Upload ref="upload" :show-upload-list="false" :on-success="handleSuccess" :max-size="10240" multiple type="drag" accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.GIF,.PNG"
                  :action="$constDefinition.baseUrl + '/file/UploadByUnacceptedOrder'" :data="{ id: initData.id, type: 10, guid: this.proveGuid }" style="width: 80px">
                  <div style="width: 80px; height: 80px; line-height: 80px" @click="handleBeforeProve">
                    <Icon type="ios-camera" size="20"></Icon>
                  </div>
                </Upload>
              </div>
            </div>
            <Row align="middle" v-if="initData.status > $constDefinition.recordedTrackingVerification && initData.status < $constDefinition.supervisorSendBack">
              <Col span="4">跟踪验证：</Col>
              <Col span="20">{{ initData.trackingVerification }}</Col>

            </Row>
            <Row align="middle" v-if="initData.status > $constDefinition.recordedTrackingVerification && initData.status < $constDefinition.supervisorSendBack && initData.proveFiles.length != 0">
              <Col span="4">相关文件：</Col>
              <Col span="20">
              <div v-if="initData.proveFiles.length > 0" class="img-box">
                <div v-for="item in initData.proveFiles" :key="item.fileGuids">
                  <img :src="$constDefinition.baseUrl + item.url" @click="previewImg(item.url)" />
                </div>
              </div>
              </Col>
            </Row>
            <Row align="middle" v-if="initData.status > $constDefinition.recordedTrackingVerification && initData.status < $constDefinition.supervisorSendBack">
              <Col span="4">填写人：</Col>
              <Col span="8">{{ initData.trackingVerificationWrittenUser }}</Col>
              <Col span="4">提交时间：</Col>
              <Col span="8">{{ initData.trackingVerificationWrittenDateText }}</Col>
              <Col span="24">
              <Table :columns="columnsTrackingVerificationConfirmRecordDtos" :data="initData.trackingVerificationConfirmRecordDtos"></Table>
              </Col>
            </Row>
          </div>

          <div v-if="initData.businessLogDtos.length > 0">
            <Divider>操作日志</Divider>
            <div>
              <Timeline>
                <TimelineItem v-for="(item, index) in initData.businessLogDtos" :key="index">
                  <p class="content">{{ item.creatorName }} {{ item.creationTimeText }}</p>
                  <p class="content">{{ item.content }} {{ item.description ? ',' + item.description : '' }}</p>
                </TimelineItem>
              </Timeline>
            </div>
          </div>
        </div>
      </Form>
      <!-- 填写人撤回表单 -->
      <div slot="footer">
        <div class="processBtn" v-if="initData.isShow_品质部员工撤回">
          <Button v-if="initData.isShow_品质部员工撤回" @click="isShowRecallInfo" type="primary" class="close-btn">撤回</Button>
        </div>
        <!-- 主管确认 -->
        <div class="processBtn" v-if="initData.status == $constDefinition.qualitySupervisorConfirm && initData.isShow_不合格处理详情_退回">
          <Button v-if="initData.isShow_不合格处理详情_退回" @click="isShowSendBack = true" type="primary" class="close-btn">退回</Button>
          <Button v-if="initData.isShow_不合格处理详情_确认" @click="preConfirmForm" type="primary" class="close-btn">确认</Button>
        </div>
        <!-- 录入处理方案 -->
        <div class="processBtn" v-if="initData.status == $constDefinition.recordedProcessingPlan && initData.isShow_临时处理方案_提交">
          <Button type="primary" @click="isLZfzr=true" class="close-btn">流转</Button>
          <Button @click="presubmitProcessingScheme" type="primary" class="close-btn">提交</Button>
        </div>

        <!-- 待会签部门确认 -->
        <div class="processBtn" v-if="initData.status == $constDefinition.countersignedDepartmentConfirm">
          <!-- 驳回方案 -->
          <Button v-if="initData.isShow_临时处理方案_会签驳回" @click="isShowRejectScheme = true" type="primary" class="close-btn">驳回</Button>
          <!-- 填写人撤回临时处理方案 -->
          <Button v-if="initData.isShow_工艺部撤回" @click="isShowRecallScheme = true" type="primary" class="close-btn">撤回</Button>
          <Button v-if="initData.isShow_临时处理方案_会签确认" @click="isShowDepartmentConfirmation = true" type="primary" class="close-btn">确认</Button>
        </div>
        <!-- 待录入处置结论 -->
        <div class="processBtn" v-if="initData.status == $constDefinition.recordedDisposalConclusion && initData.isShow_处置结论_提交">
          <Button @click="presubmitDisposalConclusion" type="primary" class="close-btn">提交</Button>
        </div>
        <!-- 待录入原因分析/改善对策 -->
        <div class="processBtn" v-if="initData.status == $constDefinition.recordedAnalysisCountermeasures && initData.isShow_原因分析按钮">
          <Button @click="isShowResponsible = true" type="primary" class="close-btn">流转</Button>
          <Button @click="saveSubmitAnalysisCauses" type="primary" class="close-btn">暂存</Button>
          <Button @click="presubmitAnalysisCauses" type="primary" class="close-btn">提交</Button>
        </div>
        <!-- 待责任主管确认 -->
        <div class="processBtn" v-if="initData.status == $constDefinition.responsibleSupervisorConfirm && initData.isShow_原因分析_确认">
          <Button @click="isShowResponsibleSupervisorConfirm = true" type="primary" class="close-btn">确认</Button>
        </div>
        <!-- 待录入跟踪验证 -->
        <div class="processBtn" v-if="initData.status == $constDefinition.recordedTrackingVerification && initData.isShow_跟踪验证_提交">
          <Button @click="presubmitTrackingVerification" type="primary" class="close-btn">提交</Button>
        </div>
        <!-- 待录入跟踪验证确认 -->
        <div class="processBtn" v-if="initData.isShow_跟踪验证_确认">
          <Button @click="confirmSaveGZYZ" type="primary" class="close-btn">确认</Button>
          <Button @click="preRejectGZYZ" type="warning" class="close-btn">驳回</Button>
        </div>

        <div class="processBtn"
          v-if="!initData.isShow_原因分析_确认 && !initData.isShow_工艺部撤回 && !initData.isShow_临时处理方案_会签驳回 && !initData.isShow_品质部员工撤回 && !initData.isShow_不合格处理详情_退回 && !initData.isShow_不合格处理详情_确认 && !initData.isShow_临时处理方案_提交 && !initData.isShow_临时处理方案_会签确认 && !initData.isShow_处置结论_提交 && !initData.isShow_原因分析按钮 && !initData.isShow_跟踪验证_提交&& !initData.isShow_跟踪验证_确认">
          <Button @click="close" class="close-btn">关闭</Button>
        </div>

        <Button @click="exportScrapDocumentFile" type="primary">导出报废单</Button>
      </div>
    </Modal>
    <!-- 填写人撤回表单 -->
    <Modal v-model="isShowRecallInfo" @on-ok="recall" @on-cancel="isShowRecallInfo = false" class="modal-cont" ok-text="确认">确认撤回吗？</Modal>
    <!-- 退回原因 -->
    <Modal v-model="isShowSendBack" title="退回原因" @on-ok="confirmBackReason" @on-cancel="isShowSendBack = false" class="modal-cont">
      <Input v-model="initData.backReason" type="textarea" :maxlength="200" :autosize="{ minRows: 5, maxRows: 5 }" placeholder="请输入退回原因(最多200个字)" />
    </Modal>
    <!-- 驳回原因 -->
    <Modal v-model="preRejectGZYZShow" title="驳回原因" @on-ok="preRejectGZYZConfirm" @on-cancel="preRejectGZYZShow = false" class="modal-cont">
      <Input v-model="reason" type="textarea" :maxlength="200" :autosize="{ minRows: 5, maxRows: 5 }" placeholder="请输入驳回原因(最多200个字)" />
    </Modal>
    <Modal v-model="isShowDirectorConfirm" @on-ok="confirmForm" @on-cancel="isShowDirectorConfirm = false" class="modal-cont" ok-text="确认">确认该不合格处理单有效？</Modal>
    <!-- 录入处理方案 -->
    <Modal v-model="isShowProcessingScheme" @on-ok="submitProcessingScheme" @on-cancel="isShowProcessingScheme = false" class="modal-cont" ok-text="确认">确认提交吗？</Modal>
    <!-- 填写人撤回临时处理方案 -->
    <Modal v-model="isShowRecallScheme" @on-ok="recall" @on-cancel="isShowRecallScheme = false" class="modal-cont" ok-text="确认">确认撤回吗？</Modal>
    <!-- 待会签部门确认 -->
    <Modal v-model="isShowDepartmentConfirmation" @on-ok="confirmInterimPlan" @on-cancel="isShowDepartmentConfirmation = false" class="modal-cont" ok-text="确认">确认同意临时处理方案吗？</Modal>
    <!-- 驳回原因 -->
    <Modal v-model="isShowRejectScheme" title="驳回原因" @on-ok="confirmRejectScheme" @on-cancel="isShowRejectScheme = false" class="modal-cont">
      <Input v-model="initData.sign_RejectedReason" type="textarea" :maxlength="200" :autosize="{ minRows: 5, maxRows: 5 }" placeholder="请输入驳回原因(最多200个字)" />
    </Modal>
    <!-- 待录入处置结论 -->
    <Modal v-model="isShowDisposalConclusion" @on-ok="submitDisposalConclusion" @on-cancel="isShowDisposalConclusion = false" class="modal-cont" ok-text="确认">确认提交吗？</Modal>
    <!-- 待录入原因分析 -->
    <Modal v-model="isShowAnalysisCauses" @on-ok="submitAnalysisCauses" @on-cancel="isShowAnalysisCauses = false" class="modal-cont" ok-text="确认">确认提交吗？</Modal>
    <!-- 流转责任人 -->
    <Modal v-if="initData.status == $constDefinition.recordedAnalysisCountermeasures" v-model="isShowResponsible" title="请选择责任人" @on-ok="confirmResponsible" @on-cancel="isShowResponsible = false" class="modal-cont">
      <RadioGroup v-model="userId">
        <Radio v-for="(item, index) in initData.responsibilityDepartmentEmployee.signDepartmentHeadUserInfos" :key="index" :label="item.departmentHeadUserId">{{ item.departmentHeadUserName }}</Radio>
      </RadioGroup>
    </Modal>
    <!-- 选择录入处理方案负责人 -->
    <Modal v-model="isLZfzr" title="选择录入处理方案负责人" @on-ok="confirmLZfzr" @on-cancel="isLZfzr = false" class="modal-cont">
      <RadioGroup v-model="userId">
        <Radio v-for="(item, index) in lzList" :key="index" :label="item.id">{{ item.name }}</Radio>
      </RadioGroup>
    </Modal>
    <!-- 责任主管确认 -->
    <Modal v-model="isShowResponsibleSupervisorConfirm" @on-ok="responsibleSupervisorConfirm" @on-cancel="isShowResponsibleSupervisorConfirm = false" class="modal-cont" ok-text="确认">确认同意原因分析/改善对策吗？</Modal>
    <!-- 待录入跟踪验证 -->
    <Modal v-model="isShowTrackingVerification" @on-ok="submitTrackingVerification" @on-cancel="isShowTrackingVerification = false" class="modal-cont" ok-text="确认">确认提交吗？</Modal>
  </div>
</template>

<script>
import Util from '../../../lib/util'

export default {
  data() {
    return {
      initData: null,
      userId: 0,
      loading: false,
      signDepartmentInfos: [],
      lzList: [],
      proveGuid: '',
      imageFilesGuid: '',
      videoFilesGuid: '',
      confirmUserNames: '',
      trackingVerificationName: '',
      reason: '',
      preRejectGZYZShow: false,
      allUserList: [],
      queryUserList: [],
      isShowSendBack: false,
      isLZfzr: false,
      isShowDirectorConfirm: false,
      isShowProcessingScheme: false,
      isShowDepartmentConfirmation: false,
      isShowDisposalConclusion: false,
      isShowResponsible: false,
      isShowAnalysisCauses: false,
      isShowResponsibleSupervisorConfirm: false,
      isShowTrackingVerification: false,
      isShowRecallInfo: false,
      isShowRecallScheme: false,
      isShowRejectScheme: false,
      rules: {
        // temporaryDisposePlanUserId: [
        //     { required: true, message: '必填信息', trigger: 'change' }
        // ],
        temporaryDisposePlan: [{ required: true, message: '必填信息', trigger: 'blur' }],
        signRecordDtos: [
          { required: true, type: 'array', min: 1, message: '必填信息', trigger: 'change' },
        ],
        // signDepartmentInfos:[
        //     { required: true, type: 'array', message: '必填信息', trigger: 'change' }
        // ],
        //驳回原因
        disposeConclusion: [
          { required: true, type: 'number', message: '必填信息', trigger: 'change' },
        ],
        disposeConclusionDescribe: [{ required: true, message: '必填信息', trigger: 'blur' }],
        responsibilityDepartment: [{ required: true, message: '必填信息', trigger: 'change' }],
        causeAnalysis: [{ required: true, message: '必填信息', trigger: 'blur' }],
        improveCountermeasure: [{ required: true, message: '必填信息', trigger: 'blur' }],
        trackingVerification: [{ required: true, message: '必填信息', trigger: 'blur' }],
        responsibilityDepartmentUserId: [
          { required: true, type: 'number', message: '必填信息', trigger: 'blur' },
        ],
        confirmUserIds: [{ required: true, type: 'array', message: '必填信息', trigger: 'change' }],
      },
      columnsSignRecordDtos: [
        {
          title: '会签部门',
          key: 'signDepartment',
        },
        {
          title: '会签主管',
          key: 'departmentHeadUserName',
        },
        {
          title: '确认时间',
          key: 'signTime_Text',
        },
      ],
      columnsTrackingVerificationConfirmRecordDtos: [
        {
          title: '确认人',
          key: 'confirmUserName',
        },
        {
          title: '发起确认时间',
          key: 'creationTime_Text',
        },
        {
          title: '确认时间',
          key: 'confirmTime_Text',
        },
      ],
    }
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    infoData: {
      required: true,
    },
    allowCGBBZWrite: {
      type: Boolean,
    },
  },
  watch: {
    'initData.confirmUserIds': {
      handler(newVal) {
        let _this = this
        if (_this.initData.confirmUserIds == null || _this.initData.confirmUserIds == undefined) {
          _this.$set(_this.initData, 'confirmUserIds', [])
        }

        let list = []
        list = _this.initData.confirmUserIds.map((user) => {
          return _this.allUserList.find((item) => {
            if (item.value == user) {
              return item.value == user
            }
          })
        })

        let nameList = list.map((item) => {
          return item.name
        })
        this.confirmUserNames = nameList.join(',')
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    const date = new Date()
    console.log(date.toString().toLowerCase())
    this.getInitData()
  },
  methods: {
    async getInitData() {
      this.$Spin.show()
      // this.$emit('loadingChange')
      const data = await this.$Ajax.get(
        `/api/services/app/UnacceptedProductProcessOrder/GetDtoByCGB?id=${this.infoData}&allowCGBBZWrite=${this.allowCGBBZWrite}`
      )
      const dataLz = await this.$Ajax.get(
        `/api/services/app/UnacceptedProductProcessOrder/GetTurnoverUserList`
      )
      this.lzList = dataLz.data.result.processDeptUserList
      this.initData = data.data.result
      this.$Spin.hide()
      this.getTrackingVerificationName(true)
      // this.$emit('loadingChange')
    },
    async getTrackingVerificationName(isinit) {
      if (isinit || this.trackingVerificationName) {
        // 保存当前已选择的用户ID和搜索结果中的用户
        const selectedUserIds = this.initData.confirmUserIds || []
        const currentQueryUsers = [...this.queryUserList]

        // 获取新的搜索结果
        const { data } = await this.$Ajax.get(
          `/api/services/app/UnacceptedProductProcessOrder/GetQueryUserListAndAllUserList?name=${this.trackingVerificationName}`
        )

        // 更新搜索结果
        this.queryUserList = data.result.queryUserList

        // 保存之前搜索结果中已选择的用户
        if (selectedUserIds.length > 0 && currentQueryUsers.length > 0) {
          const selectedQueryUsers = currentQueryUsers.filter((user) =>
            selectedUserIds.includes(user.value)
          )

          // 将之前已选择的搜索结果用户添加到新的搜索结果中
          if (selectedQueryUsers.length > 0) {
            // 获取新搜索结果中的所有用户ID
            const newQueryUserIds = this.queryUserList.map((user) => user.value)

            // 添加不在新搜索结果中的已选择用户
            selectedQueryUsers.forEach((user) => {
              if (!newQueryUserIds.includes(user.value)) {
                this.queryUserList.push(user)
              }
            })
          }
        }

        // 更新所有用户列表
        this.allUserList = data.result.allUserList

        // 如果有已选择的用户，确保它们在allUserList中存在
        if (selectedUserIds.length > 0) {
          // 获取allUserList中所有用户ID
          const allUserIds = this.allUserList.map((user) => user.value)

          // 检查并添加缺失的用户到allUserList
          selectedUserIds.forEach((userId) => {
            if (!allUserIds.includes(userId)) {
              // 查找已选用户的完整信息（从zdUserList或之前的queryUserList中）
              let userInfo = this.initData.zdUserList.find((user) => user.value === userId)

              if (!userInfo) {
                userInfo = currentQueryUsers.find((user) => user.value === userId)
              }

              if (userInfo) {
                // 将缺失的用户添加到allUserList
                this.allUserList.push(userInfo)
              }
            }
          })
        }
      }
    },
    save() {
      this.$emit('succesConfirm', false)
      this.$emit('save-success')
    },
    close() {
      this.$emit('succesConfirm', false)
    },
    visibleChange(value) {
      //这里value都为false
      if (!false) {
        this.$emit('succesConfirm', value)
      }
    },
    previewImg(item) {
      item = item.replace('previewThumbnail', 'preview')
      window.open(this.$constDefinition.baseUrl + item)
      // window.location.href = this.$constDefinition.baseUrl +item
    },
    previewVideo(item) {
      window.open(this.$constDefinition.baseUrl + item)
    },
    // 撤回表单
    recall() {
      let _this = this
      this.$Ajax
        .post(
          `/api/services/app/UnacceptedProductProcessOrder/WorkFlow_撤回?id=${this.initData.id}`
        )
        .then((res) => {
          _this.isShowRecallScheme = false
          _this.isShowRecallInfo = false
          _this.save()
        })
    },
    //主管退回原因
    confirmBackReason() {
      if (!this.initData.backReason) {
        this.$Message.error('请将表单填写完整')
      } else {
        let _this = this
        this.$Ajax
          .post('/api/services/app/UnacceptedProductProcessOrder/WorkFlow_主管退回', {
            id: this.initData.id,
            reason: this.initData.backReason,
          })
          .then((res) => {
            _this.isShowSendBack = false
            _this.save()
          })
      }
    },
    preConfirmForm() {
      if (!this.initData.temporaryDisposePlanUserId) {
        this.$Message.error('请将表单填写完整')
        return
      }
      this.isShowDirectorConfirm = true
    },
    //确认表单
    confirmForm() {
      let _this = this
      this.$Ajax
        .post(`/api/services/app/UnacceptedProductProcessOrder/WorkFlow_主管确认`, {
          id: this.initData.id,
          temporaryDisposePlanUserId: this.initData.temporaryDisposePlanUserId,
        })
        .then((res) => {
          _this.isShowDirectorConfirm = false
          _this.save()
        })
    },
    changebox() {
      let arr = []
      for (let i = 0; i < this.initData.signRecordDtos.length; i++) {
        for (let j = 0; j < this.signDepartmentInfos.length; j++) {
          if (
            this.initData.signRecordDtos[i].department == this.signDepartmentInfos[j].department
          ) {
            arr.push(this.signDepartmentInfos[j])
          }
        }
      }
      this.signDepartmentInfos = arr
      this.handleStorageTemporaryDisposePlan()
    },
    //临时处理方案断点续存
    handleStorageTemporaryDisposePlan() {
      let _this = this
      this.$Ajax
        .post('/api/services/app/UnacceptedProductProcessOrder/WorkFlow_录入处理方案', {
          id: this.initData.id,
          isUpdate: true,
          temporaryDisposePlan: this.initData.temporaryDisposePlan,
          signDepartmentInfos: this.signDepartmentInfos,
        })
        .then((res) => {
          console.log(res)
        })
    },
    //验证处理方案填写
    presubmitProcessingScheme() {
      let arr1 = []
      let arr2 = []
      this.initData.signRecordDtos.forEach((item) => {
        arr1.push(item.department)
      })
      this.signDepartmentInfos.forEach((item) => {
        arr2.push(item.department)
      })
      console.log(arr1.toString())
      console.log(arr2.toString())
      console.log(arr1.toString() === arr2.toString())
      if (arr1.toString() !== arr2.toString()) {
        this.$Message.error('请将表单填写完整')
      } else {
        this.$refs.initData.validate((valid) => {
          if (valid) {
            this.isShowProcessingScheme = true
          } else {
            this.$Message.error('请将表单填写完整')
          }
        })
      }
    },
    //提交处理方案
    submitProcessingScheme() {
      let _this = this
      this.$Ajax
        .post('/api/services/app/UnacceptedProductProcessOrder/WorkFlow_录入处理方案', {
          id: this.initData.id,
          isUpdate: false,
          temporaryDisposePlan: this.initData.temporaryDisposePlan,
          signDepartmentInfos: this.signDepartmentInfos,
        })
        .then((res) => {
          _this.isShowProcessingScheme = false
          _this.save()
        })
    },
    //会签部门确认临时处理方案
    confirmInterimPlan() {
      let _this = this
      this.$Ajax
        .post(
          `/api/services/app/UnacceptedProductProcessOrder/WorkFlow_会签部门确认?id=${this.initData.id}`
        )
        .then((res) => {
          _this.isShowDepartmentConfirmation = false
          _this.save()
        })
    },
    //会签部门驳回
    confirmRejectScheme() {
      if (!this.initData.sign_RejectedReason) {
        this.$Message.error('请将表单填写完整')
      } else {
        let _this = this
        this.$Ajax
          .post('/api/services/app/UnacceptedProductProcessOrder/WorkFlow_会签驳回', {
            id: this.initData.id,
            reason: this.initData.sign_RejectedReason,
          })
          .then((res) => {
            _this.isShowRejectScheme = false
            _this.save()
          })
      }
    },
    //处置结论断点续存
    changeConclusion() {
      // console.log(this.initData.disposeConclusion)
      if (this.initData.disposeConclusion != 30) {
        this.initData.disposeConclusionDescribe = ''
      }
      this.handleStorageDisposeConclusion()
    },
    //责任部门断点续存
    changeDepartment() {
      this.initData.responsibilityDepartmentUserId = null
      // console.log(this.initData.responsibilityDepartment)
      this.handleStorageDisposeConclusion()
    },
    //处置结论断点续存
    handleStorageDisposeConclusion() {
      this.$Ajax
        .post('/api/services/app/UnacceptedProductProcessOrder/WorkFlow_录入处置结论', {
          id: this.initData.id,
          isUpdate: true,
          disposeConclusion: this.initData.disposeConclusion,
          disposeConclusionDescribe: this.initData.disposeConclusionDescribe,
          responsibilityDepartment: this.initData.responsibilityDepartment,
          responsibilityDepartmentUserId: this.initData.responsibilityDepartmentUserId,
        })
        .then((res) => {
          console.log(res)
        })
    },
    //
    confirmSaveGZYZ() {
      let _this = this
      this.$Modal.confirm({
        title: '提示',
        content: '确认跟踪验证信息无误吗？',
        onOk: () => {
          _this.$Spin.show()
          this.$Ajax
            .post(
              '/api/services/app/UnacceptedProductProcessOrder/WorkFlow_跟踪验证确认?id=' +
                this.initData.id,
              {}
            )
            .then((res) => {
              _this.$Spin.hide()
              _this.isShowDisposalConclusion = false
              _this.save()
            })
            .catch((err) => {
              _this.$Spin.hide()
            })
        },
      })
    },
    preRejectGZYZ() {
      this.reason = ''
      this.preRejectGZYZShow = true
    },
    preRejectGZYZConfirm() {
      let _this = this

      if (this.reason == '') {
        this.$Message.error('请输入驳回理由')
        return
      }
      _this.$Spin.show()
      this.$Ajax
        .post('/api/services/app/UnacceptedProductProcessOrder/WorkFlow_跟踪验证确认驳回', {
          id: this.initData.id,
          reason: this.reason,
        })
        .then((res) => {
          _this.$Spin.hide()
          _this.preRejectGZYZShow = false
          _this.isShowDisposalConclusion = false
          _this.save()
        })
        .catch((err) => {
          _this.$Spin.hide()
        })
    },
    //验证处置结论填写
    presubmitDisposalConclusion() {
      if (this.initData.responsibilityDepartmentUserId <= 0) {
        this.$Message.error('请将表单填写完整')
        return
      }
      this.$refs.initData.validate((valid) => {
        if (valid) {
          this.isShowDisposalConclusion = true
        } else {
          this.$Message.error('请将表单填写完整')
        }
      })
    },
    //提交处置结论
    submitDisposalConclusion() {
      let _this = this
      this.$Ajax
        .post('/api/services/app/UnacceptedProductProcessOrder/WorkFlow_录入处置结论', {
          id: this.initData.id,
          isUpdate: false,
          disposeConclusion: this.initData.disposeConclusion,
          disposeConclusionDescribe: this.initData.disposeConclusionDescribe,
          responsibilityDepartment: this.initData.responsibilityDepartment,
          responsibilityDepartmentUserId: this.initData.responsibilityDepartmentUserId,
        })
        .then((res) => {
          _this.isShowDisposalConclusion = false
          _this.save()
        })
    },
    //暂存原因分析/处置结论
    handleStorageCauseAnalysis() {
      this.$Ajax
        .post('/api/services/app/UnacceptedProductProcessOrder/WorkFlow_录入原因分析和改善对策', {
          id: this.initData.id,
          isUpdate: true,
          causeAnalysis: this.initData.causeAnalysis,
          improveCountermeasure: this.initData.improveCountermeasure,
        })
        .then((res) => {
          console.log(res)
        })
    },
    //保存原因分析
    saveSubmitAnalysisCauses() {
      this.handleStorageCauseAnalysis()
      this.save()
    },
    //验证原因分析/处置结论填写
    presubmitAnalysisCauses() {
      this.$refs.initData.validate((valid) => {
        if (valid) {
          this.isShowAnalysisCauses = true
        } else {
          this.$Message.error('请将表单填写完整')
        }
      })
    },
    //提交原因分析/处置结论
    submitAnalysisCauses() {
      let _this = this
      this.$Ajax
        .post('/api/services/app/UnacceptedProductProcessOrder/WorkFlow_录入原因分析和改善对策', {
          id: this.initData.id,
          isUpdate: false,
          causeAnalysis: this.initData.causeAnalysis,
          improveCountermeasure: this.initData.improveCountermeasure,
        })
        .then((res) => {
          _this.isShowAnalysisCauses = false
          _this.save()
        })
    },
    //流转责任人
    confirmResponsible() {
      let _this = this
      this.$Ajax
        .post(
          `/api/services/app/UnacceptedProductProcessOrder/WorkFlow_录入原因分析和改善对策_流转`,
          { id: this.initData.id, userId: this.userId }
        )
        .then((res) => {
          _this.isShowResponsible = false
          _this.save()
        })
    },
    confirmLZfzr() {
      let _this = this
      this.$Ajax
        .post(`/api/services/app/UnacceptedProductProcessOrder/WorkFlow_录入处理方案_流转`, {
          id: this.initData.id,
          userId: this.userId,
        })
        .then((res) => {
          _this.isShowResponsible = false
          _this.save()
        })
    },
    //责任主管确认
    responsibleSupervisorConfirm() {
      let _this = this
      this.$Ajax
        .post(
          `/api/services/app/UnacceptedProductProcessOrder/WorkFlow_录入原因分析和改善对策_确认?id=${this.initData.id}`
        )
        .then((res) => {
          _this.isShowResponsibleSupervisorConfirm = false
          _this.save()
        })
    },
    //暂存跟踪验证
    handleStorageTrackingVerification() {
      this.$Ajax
        .post('/api/services/app/UnacceptedProductProcessOrder/WorkFlow_录入跟踪验证', {
          id: this.initData.id,
          isUpdate: true,
          trackingVerification: this.initData.trackingVerification,
          confirmUserIds: this.initData.confirmUserIds,
        })
        .then((res) => {
          console.log(res)
        })
    },
    //验证跟踪验证填写
    presubmitTrackingVerification() {
      this.$refs.initData.validate((valid) => {
        if (valid) {
          this.isShowTrackingVerification = true
        } else {
          this.$Message.error('请将表单填写完整')
        }
      })
    },
    //提交跟踪验证
    submitTrackingVerification() {
      let _this = this
      this.$Ajax
        .post('/api/services/app/UnacceptedProductProcessOrder/WorkFlow_录入跟踪验证', {
          id: this.initData.id,
          isUpdate: false,
          trackingVerification: this.initData.trackingVerification,
          confirmUserIds: this.initData.confirmUserIds,
        })
        .then((res) => {
          _this.isShowTrackingVerification = false
          _this.save()
        })
    },
    //删除图片
    handleRemove(item, index) {
      console.log('remove', item, index)
      // this.initData.proveFiles.splice(index, 1)
      this.$Ajax.delete(`/api/services/app/ComFile/DeleteFileByGuid?guid=${item.fileGuids}`)
      this.getInitData()
    },
    handleSuccess(res, file) {
      let param = {
        fileGuids: res.result.guid,
        url: res.result.imageUrl,
      }
      this.initData.proveFiles.push(param)
    },
    handleSuccessImageFiles(res, file) {
      let param = {
        fileGuids: res.result.guid,
        url: res.result.imageUrl,
      }
      this.initData.improveCountermeasureImageFiles.push(param)
    },
    handleSuccessVideoFiles(res, file) {
      console.log(res)
      let param = {
        fileGuids: res.result.guid,
        url: res.result.imageUrl,
      }
      this.initData.improveCountermeasureVideoFiles.push(param)
    },
    handleBeforeImage(file) {
      this.imageFilesGuid = this.createGuid()
      console.log(this.imageFilesGuid)
    },
    handleBeforeVideo() {
      this.videoFilesGuid = this.createGuid()
    },
    handleBeforeProve() {
      this.proveGuid = this.createGuid()
    },
    createGuid() {
      return (
        this.S4() +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        this.S4() +
        this.S4()
      )
    },
    S4() {
      console.log((((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1))
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    // 导出报废清单
    exportScrapDocumentFile() {
      var _this = this
      var scrapInfo = this.initData
      //console.log(scrapInfo)
      if (!scrapInfo.materialName) {
        scrapInfo.materialName = ''
      }
      if (!scrapInfo.materialCode) {
        scrapInfo.materialCode = ''
      }
      if (!scrapInfo.unacceptedDescribe) {
        scrapInfo.unacceptedDescribe = ''
      }
      if (!scrapInfo.ResponsibilityDepartmentUserName) {
        scrapInfo.ResponsibilityDepartmentUserName = ''
      }
      //console.log(Util.abp.auth.getToken())
      //const date = this.$moment(new Date()).format('yyyyMMDDHHmm');
      let consturl =
        `${this.$constDefinition.baseUrl}/api/Export/ExportScrapDocument?MaterialName=${scrapInfo.materialName}` +
        `&MaterialCode=${scrapInfo.materialCode}` +
        `&UnacceptedCount=${scrapInfo.unacceptedCount}` +
        `&UnacceptedDescribe=${scrapInfo.unacceptedDescribe}` +
        `&ResponsibilityDepartmentUserName=${scrapInfo.responsibilityDepartmentUserName}` //下载地址url
      //window.location.href = consturl;
      var xhr = new XMLHttpRequest()
      xhr.open('get', consturl, true) // get、post都可
      xhr.responseType = 'blob'
      xhr.setRequestHeader('Authorization', `Bearer ${Util.abp.auth.getToken()}`) //加请求头
      xhr.onload = function () {
        if (xhr.status == 200) {
          let blob = new Blob([this.response], {
            type: 'application/vnd.ms-excel',
          })
          var a = document.createElement('a')
          var url = window.URL.createObjectURL(blob)
          a.href = url
          a.download = `报废申请单(${scrapInfo.materialCode})` // 文件名
          if (xhr.readyState === 4) {
            _this.$Message.success({
              content: '下载成功',
            })
          }
        } else {
          _this.$Message.error({
            content: '下载失败',
          })
        }
        a.click()
        window.URL.revokeObjectURL(url)
      }
      xhr.send()
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.ivu-modal-header-inner {
  font-size: 20px;
  text-align: center;
}
/deep/.ivu-form-item-label {
  font-size: 16px;
}
.title {
  font-size: 16px;
}

.cont {
  min-height: 400px;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.cont::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

.department {
  display: flex;
}
.time {
  margin-left: 50px;
}
/deep/.ivu-modal-footer {
  text-align: center;
}
// /deep/.ivu-divider-inner-text{
//     font-size: 16px;
// }
.ivu-row {
  font-size: 15px;
  min-height: 20px;
  margin-top: 5px;
  // border-bottom: 1px solid #ccc;
}

.img-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.img-box img,
.img-box video {
  width: 80px;
  height: 80px;
  margin: 0 10px 0 0;
}

.video-box .icon {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  margin: 0 10px 0 0;
  // border: 1px solid red;
}

.modal-cont /deep/ .ivu-modal-body {
  font-size: 20px;
  text-align: center;
}
.modal-cont /deep/ .ivu-modal {
  top: 300px;
}

// 文件上传
.cont-img {
  width: 100%;
  display: flex;
}
.demo-upload-list {
  display: inline-block;
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  position: relative;
  margin-right: 4px;
}
.demo-upload-list img {
  width: 100%;
  height: 100%;
}

.demo-upload-list-cover i {
  position: absolute;
  top: 0;
  right: 0;
  color: #999;
  font-size: 20px;
  cursor: pointer;
  margin: 0 2px;
}

.label /deep/ .ivu-form-item-label {
  font-size: 14px;
}

.processBtn {
  display: inline-block;
  margin-right: 10px;
}
.custom-block.danger {
  background-color: #ffe6e6;
  border-color: #c00;
  color: #4d0000;
  //   padding: 10px;
  border-radius: 5px;
  //   margin-bottom: 10px;
}
.custom-block.danger,
.custom-block.tip,
.custom-block.warning {
  padding: 0.5rem;
  border-left-width: 0.5rem;
  border-left-style: solid;
  margin: 1rem 0;
}
.custom-block.danger .custom-block-title {
  color: #900;
}
</style>
